<template>
    <div>
        <p>依据中华人民共和国有关法律法规，提交作品的参赛方同意向主办方就其提交的作品做出如下声明：</p>
        <p>1．本人所呈交的参赛作品，是本人创意并设计，对该作品拥有完整、合法的著作权及其他相关权益。</p>
        <p>2．呈交作品中不含任何其他个人或集体已经发表或设计过的作品成果，并承诺若作品存在抄袭或其他侵权行为，本人自动取消参赛资格，并赔偿主办方因此所受的一切损失（包括但不限于赔偿金、诉讼费、律师费、公证费、鉴定费等）。</p>
        <p>3．本人同意授权主办方合理使用本人的作品（包括但不限于媒体宣传、大赛官网浏览及下载、展览（含巡展）等活动项目且无需支付任何使用费。</p>
    </div>
</template>